import ReactDOMServer from 'react-dom/server';
import { download, generateCsv, mkConfig } from 'export-to-csv';
import { SVGMol, SVGMolSpace } from '@moleculeone/ui';
import { DrawnMol } from '@moleculeone/types';
import { SearchResultInList } from '@retro-ui/api-contract';

export function savePngMol(drawnMol: DrawnMol, width: number, height: number, name: string) {
  const svgEncoded = renderSVG(drawnMol, width, height);
  const image = new Image();
  image.width = width;
  image.height = height;
  image.onload = () => {
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const context = canvas.getContext('2d');
    if (context) {
      context.drawImage(image, 0, 0);
    }
    downloadFile(`data:image/png;${canvas.toDataURL('image/png')}`, name);
  };
  image.src = `data:image/svg+xml;base64,${btoa(svgEncoded)}`;
}

export function saveSvgMol(drawnMol: DrawnMol, width: number, height: number, name: string) {
  const svgEncoded = encodeURIComponent(renderSVG(drawnMol, width, height));
  downloadFile(`data:image/svg+xml;charset=utf-8,${svgEncoded}`, name);
}

export function renderSVG(drawnMol: DrawnMol, width: number, height: number) {
  return ReactDOMServer.renderToStaticMarkup(
    <SVGMolSpace border={50} viewport={drawnMol.bbox} height={height} width={width}>
      <SVGMol drawnMol={drawnMol} showWarnings={false} />
    </SVGMolSpace>
  );
}

export function saveText(content: string, name: string) {
  downloadFile(`data:text/plain;charset=utf-8,${encodeURIComponent(content)}`, name);
}

export function saveAsCSV(
  contents: { [k: string]: unknown; [k: number]: unknown }[] | SearchResultInList[],
  name: string,
  customOptions = {}
) {
  const csvConfig = mkConfig({ filename: name, quoteStrings: true, ...customOptions });
  const csv = generateCsv(csvConfig)(contents);
  download(csvConfig)(csv);
}

export function downloadFile(string: string, name: string) {
  const element = document.createElement('a');
  element.setAttribute('href', string);
  element.setAttribute('download', name);
  element.style.display = 'none';
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
}

export function saveAsJson(data: any, filename: string, stringify = true) {
  const json = stringify ? JSON.stringify(data, null, 2) : data;
  const blob = new Blob([json], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  downloadFile(url, filename);
  URL.revokeObjectURL(url);
}
